import React from "react";
import { withRouter } from "us.common/wIthRouter";
import Admin from "us.collection.admin";

interface ICntNonProductionDaysHome {}
const Cnt_NonProductionDaysHome: React.FC<ICntNonProductionDaysHome> = (
  props
) => {
  return (
    <>
      <Admin.Components.NonProductionDays.NonProductionDaysHome {...props} />
    </>
  );
};

export default withRouter(Cnt_NonProductionDaysHome);
